import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _omitBy from 'lodash/omitBy';
import Loads from 'react-loads';

import { withRouter } from '@medipass/react-core/router';
import WithErrorMessage from '@medipass/react-core/WithErrorMessage';
import WithLoadingIndicator from '@medipass/react-core/WithLoadingIndicator';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import MemberDetailsForm from 'legacy/components/account/members/MemberDetailsForm';
import WithAuthentication from 'legacy/components/WithAuthentication';
import { updateMembersHealthFundAccount } from 'legacy/utils/health-fund-accounts';
type Props = {
  history: (...args: Array<any>) => any;
};

class CreateMember extends React.PureComponent<Props> {
  handleAddMember = async (data: Record<string, any>) => {
    const { history } = this.props;

    const accountId = _get(sdk, 'account._id');

    const dobArray = data.dob.split('/');

    const body = _omitBy(
      {
        firstName: data.firstName,
        lastName: data.lastName,
        dobString: `${dobArray[2]}-${dobArray[1]}-${dobArray[0]}`,
        mobile: data.mobile,
        email: data.email,
      },
      _isEmpty,
    );

    const member = await sdk.members.createAccountMember(accountId, body);

    if (_get(data, 'healthFundAccount.cardRank')) {
      const healthFundAccount = data.healthFundAccount;
      await updateMembersHealthFundAccount({
        healthFundAccount,
        memberId: member._id,
      });
    }

    if (_get(data, 'medicareAccount.cardRank')) {
      const medicareAccount = data.medicareAccount;
      await updateMembersHealthFundAccount({
        healthFundAccount: medicareAccount,
        memberId: member._id,
      });
    }

    // @ts-expect-error TS(2339): Property 'push' does not exist on type '(...args: ... Remove this comment to see the full error message
    history.push('/account/members/');
    return member;
  };
  // @ts-expect-error TS(2339): Property 'push' does not exist on type '(...args: ... Remove this comment to see the full error message
  handleClickCancel = () => this.props.history.push('/account/members/');
  getMemberResources = async () => {
    const member = await sdk.members.getMember(_get(sdk, 'member._id'));
    let healthFundAccount = null;
    let medicareAccount = null;

    if (member.defaultHealthFundAccountId) {
      healthFundAccount = await sdk.healthFundAccounts.getMembersHealthFundAccount(
        member._id,
        member.defaultHealthFundAccountId,
      );
    }

    if (member.medicareHealthFundAccountId) {
      medicareAccount = await sdk.healthFundAccounts.getMembersHealthFundAccount(
        member._id,
        member.medicareHealthFundAccountId,
      );
    }

    return {
      healthFundAccount,
      medicareAccount,
    };
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Add a new member">
        <Loads loadOnMount load={this.getMemberResources}>
          {/* @ts-expect-error TS(7031): Binding element 'response' implicitly has an 'any'... Remove this comment to see the full error message */}
          {({ response, error, isError, isLoading, isSuccess }) => {
            const { healthFundAccount, medicareAccount } = response || {};
            return (
              <WithLoadingIndicator isActive={isLoading}>
                <WithErrorMessage isActive={isError} description="Unable to load health fund" error={error}>
                  {isSuccess && (
                    <MemberDetailsForm
                      initialValues={{
                        firstName: '',
                        lastName: '',
                        dob: '',
                        mobile: '',
                        email: '',
                        healthFundAccount: {
                          healthFundId: _get(healthFundAccount, 'healthFund._id', ''),
                          cardIssueNumber: _get(healthFundAccount, 'cardIssueNumber', ''),
                          cardNumber: _get(healthFundAccount, 'cardNumber', ''),
                          issueDate: healthFundAccount
                            ? [healthFundAccount.issueDay, healthFundAccount.issueMonth, healthFundAccount.issueYear]
                                .filter(x => x)
                                .join('/')
                            : '',
                          membershipNumber: _get(healthFundAccount, 'membershipNumber', ''),
                          cardRank: '',
                        },
                        medicareAccount: {
                          healthFundId: _get(medicareAccount, 'healthFund._id', ''),
                          cardRank: '',
                          expiryDate: medicareAccount
                            ? [medicareAccount.expiryMonth, medicareAccount.expiryYear].filter(x => x).join('/')
                            : '',
                          membershipNumber: _get(medicareAccount, 'membershipNumber', ''),
                        },
                      }}
                      isDependant
                      isSelectHealthFundDisabled={!Boolean(healthFundAccount)}
                      isSelectMedicareDisabled={!Boolean(medicareAccount)}
                      onClickCancel={this.handleClickCancel}
                      onSubmit={this.handleAddMember}
                    />
                  )}
                </WithErrorMessage>
              </WithLoadingIndicator>
            );
          }}
        </Loads>
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(CreateMember);
